<template>
  <div class="pa-4">
    <portal to="app-header">
      <router-link
        to="/speak"
        class="ml-2"
      >
        看看示例
      </router-link>
    </portal>
    <div class="d-flex">
      <a href="https://developer.mozilla.org/en-US/docs/Web/API/SpeechSynthesisUtterance">SpeechSynthesisUtterance - Web APIs - MDN Web Docs</a>
    </div>
    <CodeHighlight :code="code" />
  </div>
</template>

<script>
import CodeHighlight from '@/modules/codehl/CodeHighlight.vue';

export default {
  components: {
    CodeHighlight,
  },
  data() {
    return {
      code: `// ..
  methods: {
    hanleClick() {
      const speech = new SpeechSynthesisUtterance();
      speech.text = this.text;
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      // speech.lang = 'zh-CN';
      window.speechSynthesis.speak(speech);
      // this.text = '';
      // this.$refs.textarea.focus()
    }
  // ..
`,
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped>
.v-btn {
  margin-right: 10px;
}
</style>